const { h, render, Component } = require('preact');
const ClaimLevelSSA = require('../claim_level_ssa')

const TRANSACTIONS_LEVEL_SSAs = ['cashback_not_found']

class SSAButtons extends Component {
  constructor(props) {
    super(props);
  }

  getTransactionsLevelSSAs(){
    return TRANSACTIONS_LEVEL_SSAs;
  }

  render() {
    let  transactionsLevelSSAs = this.getTransactionsLevelSSAs();
    return(
      <div>
        {(transactionsLevelSSAs.length > 0) &&
        <ClaimLevelSSA
          claimDetails = {this.props.claimDetails}
          SSAs = {transactionsLevelSSAs}
        />
        }
      </div>

    );
  }
}
module.exports = SSAButtons
